import { Grid } from "@mui/material";
import React from "react";
import Tableau from "../../../../components/tableau/Tableau";
import { FonctionPoste, Utilisateur } from "../../../../services/Api/swagger";
import { getInfoTableau } from "../../helpers";
import styles from "../../styles";
import {
  utilisateursBesseTableauHeader,
  utilisateursTableauHeader,
} from "../../tableauHeader";

interface Props {
  classes?: any; // Surcharge de style CSS injecté par withStyles
  page: number;
  nbrElementParPage: number;
  sortColumn: string;
  sortOrder: "asc" | "desc";
  searchCount: number;
  searchResults: Utilisateur[];
  searchParams?: any;

  onChangeNbrElementParPage(nbrElementParPage: number): void;

  onChangePage(page: number): void;

  onChangeTri(sortColumn: string, sortOrder: string): void;

  onlyBesse?: boolean;
  fonctionsPostes?: FonctionPoste[];

  onChangeStatut?(id: string | number, statut: boolean): void;

  handleConsulter(username: string): void;

  isChargeClienteleBesse: boolean;
}

function ResultatsRecherche({
  nbrElementParPage,
  page,
  searchResults,
  searchParams,
  searchCount,
  sortColumn,
  sortOrder,
  onlyBesse,
  fonctionsPostes,
  onChangeStatut,
  handleConsulter,
  isChargeClienteleBesse,
  onChangeTri,
  onChangeNbrElementParPage,
  onChangePage,
}: Props) {
  const handleTrier = (
    event: React.MouseEvent<Element, MouseEvent> | null,
    colonneId: string
  ) => {
    let order = "asc";
    if (sortOrder === "asc") {
      order = "desc";
    }
    onChangeTri(colonneId, order);
  };

  const handleChangerPage = (
    event: React.MouseEvent<Element, MouseEvent> | null,
    page: number
  ) => {
    onChangePage(page);
  };

  const handlechangerNbrResultatParPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    nbrElement: number
  ) => {
    onChangeNbrElementParPage(nbrElement);
  };

  const onDelete = () => {};
  const onGenerer = () => {};

  const filtresBesse = onlyBesse || (searchParams && searchParams.profilBesse);

  const donneesTableau = getInfoTableau(
    searchResults,
    fonctionsPostes,
    filtresBesse
  );
  return (
    <React.Fragment>
      <Grid container sx={styles}>
        <Tableau
          isPaginer={true}
          page={page}
          type="utilisateurs"
          headerDonnees={
            filtresBesse
              ? utilisateursBesseTableauHeader
              : utilisateursTableauHeader
          }
          trierPar={sortColumn}
          ordreDeTrie={sortOrder}
          donneesTableau={donneesTableau}
          alerteEnCoursSuppression={false}
          nbrElementTotal={searchCount}
          nbrElementParPage={nbrElementParPage}
          onTrier={handleTrier}
          onConsulter={handleConsulter}
          onDelete={onDelete}
          onGenerer={onGenerer}
          onChangerPage={handleChangerPage}
          onChangerNbrResultatParPage={handlechangerNbrResultatParPage}
          onChangeStatut={onChangeStatut}
          isChargeClienteleBesse={isChargeClienteleBesse}
        />
      </Grid>
    </React.Fragment>
  );
}

export default ResultatsRecherche;
